import QueryAndMutationForStarterpack, {QueryAndMutationForStarterpackObject, UpdateStarterpackInput} from './QueryMutation';
export {QueryAndMutationForStarterpackObject, UpdateStarterpackInput};
export default QueryAndMutationForStarterpack;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackDetail/components/QueryMutation/index.ts